import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { setRightAsidePanel, toggleRightAside } from 'actions/ui';
import { hasModule } from 'helpers/profile';
import config from '../../../../config';
import { SystemText } from 'e4shared';
import { adminMenus } from './adminMenu';

export const AdminMenu = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const { rightAsideOpen, rightAsideTab } = useSelector(state => state.ui);
    const hasMetrics = user.crmIntegration || user.integrations?.filter(i => i.data_Integration).length > 0;
    const [menus, setMenus] = React.useState([]);

    React.useEffect(() => {
        const temp = ([...adminMenus] || []).reduce((all, m) => {
            const parent = { ...m };
            parent.children = m.children ? [...m.children].filter(c => !c.module || hasModule(user, c.module)) : null;
            return !m.module || hasModule(user, m.module) ? all.concat([parent]) : all;
        }, []);

        setMenus(temp);
    }, [user?.companySettings?.modules]);

    const tabIndex = () => {
        return rightAsideOpen ? '40' : '-1';
    };

    return (
        <>
            <ul className="nav nav-tabs nav-justified control-sidebar-tabs">
                {menus.map((menu, index) => {
                    if (menu.switch && !config.switches[menu.switch]) return null;
                    const active = rightAsideTab === menu.icon || (!rightAsideTab && index === 0);
                    return (
                        <li
                            key={`menu-right-${index}`}
                            data-testid={`menu-right-${menu.ref?.toLowerCase()}`}
                            className={active ? 'active' : ''}
                        >
                            <button
                                tabIndex={tabIndex()}
                                className="btn-link"
                                onClick={() => dispatch(setRightAsidePanel(menu.icon))}
                                data-toggle="tab"
                                aria-label={menu.ref}
                            >
                                <i className={`fa ${menu.icon}`} />
                            </button>
                        </li>
                    );
                })}
            </ul>
            {menus.map((menu, index) => {
                if (menu.switch && !config.switches[menu.switch]) return null;
                if (menu.companySetting && !menu.companySetting(user.companySettings)) return null;
                const active = rightAsideTab === menu.icon || (!rightAsideTab && index === 0);
                return (
                    <div key={index} className="tab-content">
                        <div className={`tab-pane ${active ? 'active' : ''}`}>
                            <div className="mt20">
                                {menu.children.map((child, index) => {
                                    if (child.switch && !config.switches[child.switch]) return null;
                                    if (child.companySetting && !child.companySetting(user.companySettings)) return null;
                                    if (child.metricsOnly && !hasMetrics) return null;
                                    const label = SystemText(`Admin/Menu/${child.ref}/Title`);
                                    return (
                                        <Link
                                            tabIndex={tabIndex()}
                                            onClick={() => dispatch(toggleRightAside())}
                                            key={index}
                                            data-testid={`submenu-right-${child.ref?.toLowerCase()}`}
                                            className="sidebar-admin-link"
                                            to={`/admin${child.route}`}
                                            aria-label={`Navigate to ${label}`}
                                        >
                                            <label className="control-sidebar-subheading">{label}</label>
                                            <p>{SystemText(`Admin/Menu/${child.ref}/Description`)}</p>
                                        </Link>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default AdminMenu;
